<div>
  <div class="header-style">
    <div></div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>
      <mat-icon (click)="openAddLogo()" class="cursor add-icon" svgIcon="add" aria-hidden="false" i18n-aria-label="@@addLogo" aria-label="Add logo"></mat-icon>
    </div>
  </div>
  <div cdkDropList class="example-list">
    @for (item of logosList; track item; let itemIndex = $index) {
      <div>
        <div class="example-custom-placeholder"></div>
        <mat-card class="cursor w-100 mb-16 mr-16">
          <mat-card-content class="lite-box logo-card">
            <img class="product-img" [src]="item.picturePath" i18n-alt="@@logoImageAlt" alt="Logo image">
            <div class="content-box">
              <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip>{{item.title}}</div>
              <mat-icon class="cursor" (click)="deleteLogo(item.id)" color="warn" i18n-aria-label="@@deleteLogo" aria-label="Delete logo">delete_outline</mat-icon>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    }
  </div>
